export type InvalidationAtom = number
export const invalidate = (invalidationIndex: number): number =>
    invalidationIndex + 1
export const defaultInvalidationAtom = 0
